// test146
(146 && 0);
